import React, { useState, useEffect } from 'react';
import './Menu.css';
import menuData from '../rajnismenu.json';
import pannerTikka from '../assets/m1.jpg';
import chicken65 from '../assets/m2.jpg';
import samosas from '../assets/m3.jpg';
import butterChicken from '../assets/butter-chicken.jpg';
import biryani from '../assets/m5.jpg';
import dalMakhani from '../assets/m6.jpg';
import naan from '../assets/m7.jpg';
import garlicNaan from '../assets/m8.jpg';
import roti from '../assets/roti.jpg';
import gulabJamun from '../assets/m10.jpg';
import kheer from '../assets/m10.jpg';
import rasMalai from '../assets/m11.jpg';
import mangoLassi from '../assets/m12.jpg';
import masalaChai from '../assets/m13.jpg';
import sweetLassi from '../assets/m14.jpg';

const Menu = () => {
  const [activeCategory, setActiveCategory] = useState('Appetizers');
  const [processedMenuData, setProcessedMenuData] = useState({});
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Process JSON data and group by categories
  useEffect(() => {
    const groupedData = {};
    menuData.forEach(item => {
      const category = item['Source Category'];
      if (!groupedData[category]) {
        groupedData[category] = [];
      }
      groupedData[category].push({
        id: `${category}-${item['Source Item']}`,
        name: item['Source Item'],
        price: item['Source Price'],
        description: getDescriptionForItem(item['Source Item'], category),
        image: getImageFromPath(item['Image Path']) || getImageForItem(item['Source Item'], category),
        spicy: isSpicyItem(item['Source Item']),
        vegetarian: isVegetarianItem(item['Source Item'])
      });
    });
    setProcessedMenuData(groupedData);
  }, []);

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isDropdownOpen && !event.target.closest('.filter-dropdown')) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  const handleCategorySelect = (categoryId) => {
    setActiveCategory(categoryId);
    setIsDropdownOpen(false);
  };

  // Helper functions
  const getImageFromPath = (imagePath) => {
    if (!imagePath) return null;
    
    // Convert the relative path to a public URL path
    // This will work with images placed in the public folder
    try {
      // Convert from src/assets/ to public/assets/ path
      const publicPath = imagePath.replace('../assets/', '/assets/');
      return publicPath;
    } catch (error) {
      // If image doesn't exist, return null to use fallback
      return null;
    }
  };

  const getDescriptionForItem = (itemName, category) => {
    const descriptions = {
      'Appetizers': 'Delicious appetizers to start your meal',
      'Soups': 'Warm and comforting soups',
      'Tandoor': 'Freshly baked in our traditional tandoor oven',
      'Dosa Corner': 'Authentic South Indian dosas',
      'South Indian Specialties': 'Traditional South Indian delicacies',
      'South Indian Combos': 'Complete South Indian meal combinations',
      'Indo Chinese': 'Fusion of Indian and Chinese flavors',
      'Curries': 'Rich and flavorful curries',
      'Biryani / Pulao': 'Aromatic rice dishes',
      'Breads': 'Freshly made traditional breads',
      'Desserts': 'Sweet treats to end your meal',
      'Beverages': 'Refreshing drinks and beverages',
      'Sides': 'Perfect accompaniments to your meal'
    };
    return descriptions[category] || 'Delicious Indian cuisine';
  };

  const getImageForItem = (itemName, category) => {
    // Create a safe filename from the item name
    const safeFileName = itemName
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '') // Remove special characters except spaces and hyphens
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
      .trim();
    
    // Map category names to folder names
    const categoryFolderMap = {
      'Appetizers': 'appetizers',
      'Soups': 'soups',
      'Tandoor': 'tandoor',
      'Dosa Corner': 'dosa-corner',
      'South Indian Specialties': 'south-indian-specialties',
      'South Indian Combos': 'south-indian-combos',
      'Indo Chinese': 'indo-chinese',
      'Curries': 'curries',
      'Biryani / Pulao': 'biryani-pulao',
      'Breads': 'breads',
      'Desserts': 'desserts',
      'Beverages': 'beverages',
      'Sides': 'sides'
    };
    
    const folderName = categoryFolderMap[category] || 'appetizers';
    
    // For now, use category-based fallback images until you add the JPG images
    // When you add your JPG images, you can uncomment the code below and comment out the fallback
    const categoryImages = {
      'Appetizers': chicken65,
      'Soups': pannerTikka,
      'Tandoor': naan,
      'Dosa Corner': roti,
      'South Indian Specialties': biryani,
      'South Indian Combos': butterChicken,
      'Indo Chinese': chicken65,
      'Curries': butterChicken,
      'Biryani / Pulao': biryani,
      'Breads': naan,
      'Desserts': gulabJamun,
      'Beverages': mangoLassi,
      'Sides': dalMakhani
    };
    
    return categoryImages[category] || pannerTikka;
    
    // TODO: Uncomment this section when you add your JPG images
    /*
    try {
      const imagePath = require(`../assets/menu-images/${folderName}/${safeFileName}.jpg`);
      return imagePath;
    } catch (error) {
      // Fallback to category-based default images if specific image not found
      const categoryImages = {
        'Appetizers': chicken65,
        'Soups': pannerTikka,
        'Tandoor': naan,
        'Dosa Corner': roti,
        'South Indian Specialties': biryani,
        'South Indian Combos': butterChicken,
        'Indo Chinese': chicken65,
        'Curries': butterChicken,
        'Biryani / Pulao': biryani,
        'Breads': naan,
        'Desserts': gulabJamun,
        'Beverages': mangoLassi,
        'Sides': dalMakhani
      };
      
      return categoryImages[category] || pannerTikka;
    }
    */
  };

  const isSpicyItem = (itemName) => {
    const spicyKeywords = ['spicy', 'hot', 'pepper', 'chili', 'masala', 'tandoor'];
    return spicyKeywords.some(keyword => 
      itemName.toLowerCase().includes(keyword)
    );
  };

  const isVegetarianItem = (itemName) => {
    const nonVegKeywords = ['chicken', 'mutton', 'lamb', 'beef', 'pork', 'fish', 'seafood', 'egg'];
    return !nonVegKeywords.some(keyword => 
      itemName.toLowerCase().includes(keyword)
    );
  };

  const menuCategories = [
    { id: 'Appetizers', name: 'Appetizers', icon: 'fas fa-seedling' },
    { id: 'Soups', name: 'Soups', icon: 'fas fa-bowl-food' },
    { id: 'Tandoor', name: 'Tandoor', icon: 'fas fa-fire' },
    { id: 'Dosa Corner', name: 'Dosa Corner', icon: 'fas fa-circle' },
    { id: 'South Indian Specialties', name: 'South Indian Specialties', icon: 'fas fa-star' },
    { id: 'South Indian Combos', name: 'South Indian Combos', icon: 'fas fa-utensils' },
    { id: 'Indo Chinese', name: 'Indo Chinese', icon: 'fas fa-pepper-hot' },
    { id: 'Curries', name: 'Curries', icon: 'fas fa-bowl-food' },
    { id: 'Biryani / Pulao', name: 'Biryani / Pulao', icon: 'fas fa-rice' },
    { id: 'Breads', name: 'Breads', icon: 'fas fa-bread-slice' },
    { id: 'Desserts', name: 'Desserts', icon: 'fas fa-ice-cream' },
    { id: 'Beverages', name: 'Beverages', icon: 'fas fa-coffee' },
    { id: 'Sides', name: 'Sides', icon: 'fas fa-plate-wheat' }
  ];


  return (
    <section className="menu" id="menu">
      <div className="menu-container">
        {/* Section Header */}
        <div className="menu-header">
         
          <h2 className="menu-title">
            Dishes to Explore Here at Rajni
          </h2>
          <p className="menu-subtitle">
            Embark on a culinary journey through our carefully curated selection of 
            traditional Indian delicacies, each crafted with authentic spices and time-honored techniques.
          </p>
        </div>

        {/* Category Tabs */}
        <div className="menu-categories">
          {/* Desktop Filter Buttons */}
          <div className="filter-buttons">
            {menuCategories.map((category) => (
              <button
                key={category.id}
                className={`category-btn ${activeCategory === category.id ? 'active' : ''}`}
                onClick={() => setActiveCategory(category.id)}
              >
                <i className={category.icon}></i>
                <span>{category.name}</span>
              </button>
            ))}
          </div>

          {/* Mobile Dropdown Filter */}
          <div className="filter-dropdown">
            <button
              className="dropdown-trigger"
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            >
              <span>{menuCategories.find(cat => cat.id === activeCategory)?.name || 'Select Category'}</span>
              <i className={`fas fa-chevron-down ${isDropdownOpen ? 'rotated' : ''}`}></i>
            </button>
            
            {isDropdownOpen && (
              <div className="dropdown-menu">
                {menuCategories.map((category) => (
                  <button
                    key={category.id}
                    className={`dropdown-item ${activeCategory === category.id ? 'active' : ''}`}
                    onClick={() => handleCategorySelect(category.id)}
                  >
                    <i className={category.icon}></i>
                    <span>{category.name}</span>
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Menu Items Grid */}
        <div className="menu-grid">
          {processedMenuData[activeCategory] && processedMenuData[activeCategory].map((item) => (
            <div key={item.id} className="menu-item">
              <div className="item-image">
                <img src={item.image} alt={item.name} />
                <div className="item-badges">
                  {item.spicy && <span className="badge spicy">🌶️ Spicy</span>}
                  {item.vegetarian && <span className="badge vegetarian">🥬 Veg</span>}
                </div>
              </div>
              <div className="item-content">
                <div className="item-header">
                  <h3 className="item-name">{item.name}</h3>
                  <span className="item-price">{item.price}</span>
                </div>
                <p className="item-description">{item.description}</p>
                <button className="order-btn">
                  {/* <i className="fas fa-plus"></i> */}
                  View Menu
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="menu-cta">
          <div className="cta-content">
            <h3 className="cta-title">Ready to Experience Authentic Indian Cuisine?</h3>
            <p className="cta-description">
              Visit us today or order online to enjoy our delicious traditional dishes
            </p>
            <div className="cta-buttons">
              <button className="primary-cta-btn">
                <i className="fas fa-phone"></i>
                Call Now
              </button>
              <button className="secondary-cta-btn">
                <i className="fas fa-shopping-cart"></i>
                Order Online
              </button>
              <button className="view-menu-btn">
                <i className="fas fa-book-open"></i>
                View Full Menu
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Menu;
